import { FileText, Link2, Globe, Search, type LucideIcon } from 'lucide-react'
import { Chip, Input } from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

export type FilterId = 'all' | 'drafts' | 'public' | 'link'

export type FilterCounts = Partial<Record<FilterId, number>>

interface Props {
  active: FilterId
  onChange: (id: FilterId) => void
  search: string
  onSearchChange: (s: string) => void
  counts?: FilterCounts
}

type ListMessages = (typeof messages)['ru']

const chips: Array<{
  id: FilterId
  label: (m: ListMessages) => string
  icon: LucideIcon | null
}> = [
  { id: 'all', label: (m) => m.filterAll, icon: null },
  { id: 'drafts', label: (m) => m.filterDrafts, icon: FileText },
  { id: 'link', label: (m) => m.filterLink, icon: Link2 },
  { id: 'public', label: (m) => m.filterPublic, icon: Globe },
]

export const ListFilters = ({ active, onChange, search, onSearchChange, counts = {} }: Props) => {
  const m = useMessages(messages)
  return (
    <div className="space-y-4">
      <div className="relative">
        <Search className="absolute left-5 top-1/2 size-5 -translate-y-1/2 text-muted-foreground" />
        <Input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={m.searchPlaceholder}
          className="h-14 rounded-2xl border-0 bg-foreground/5 pl-14 text-base"
        />
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {chips.map(({ id, label, icon: Icon }) => (
          <Chip
            key={id}
            active={active === id}
            onClick={() => onChange(id)}
            icon={Icon ?? undefined}
            count={counts[id]}
          >
            {label(m)}
          </Chip>
        ))}
      </div>
    </div>
  )
}
